import { computed } from "vue";
import { usePlans } from "@/features/subscribe/composables/usePlans.js";
import { usePlanPrice } from "@/features/subscribe/composables/usePlanPrice.js";
import type { Plan, PlanBilling } from "@/features/subscribe/types.ts";

// assuming plan with the least max_members is the most expensive
const findMostExpensivePlan = (plans: Plan[], billing: PlanBilling) =>
  plans
    .filter((plan) => plan.recurring_interval === billing)
    .reduce((min, current) =>
      min ? (current.max_members < min.max_members ? current : min) : current
    );

export const usePlanComparisonPrice = () => {
  const { allPlans } = usePlans();

  const planToCompareAgainst = computed(
    () =>
      findMostExpensivePlan(allPlans.value, "monthly") ??
      findMostExpensivePlan(allPlans.value, "annually") ??
      findMostExpensivePlan(allPlans.value, "2-yearly")
  );

  return usePlanPrice(planToCompareAgainst, "per-member-monthly");
};
